var r = {};
export {
  r as __exports
};
//# sourceMappingURL=use-sync-external-store-shim.production.js.map
